export type Quad = 1 | 2 | 3 | 4;

export type QuadEightyTwenty = '80' | '20';

/**
 * The reason this value is 0.805 and NOT 0.8 is because
 * they add some buffer to the "80" entity in that as a rule of
 * thumb they take the "80" entity + 1 extra. That roughly translates
 * to 0.805 so they use this value instead.
 */
export enum QuadEightyTwentyRange {
	// Anything <=0.805 is an "80"
	'Eighty' = 0.805,
	// Anything >0.805 is a "20"
	'Twenty' = 1,
}
